import { render, staticRenderFns } from "./solutionCard.vue?vue&type=template&id=7b85a0e7&scoped=true&"
import script from "./solutionCard.vue?vue&type=script&lang=js&"
export * from "./solutionCard.vue?vue&type=script&lang=js&"
import style0 from "./solutionCard.vue?vue&type=style&index=0&id=7b85a0e7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b85a0e7",
  null
  
)

export default component.exports